import { Dashboard, LocationList } from '@/components';

export const LocationListPage = (): JSX.Element => (
  <Dashboard>
    <LocationList />
  </Dashboard>
);
